import React from 'react';

import { faExchangeAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Stack, Box, Typography } from '@mui/material';

import { Position } from '../../../../../../types/position';
import { RecalculationMode } from '../../../../../../types/strategy';
import { roundStringNumber } from '../../../../../../utils';
import { Nullable } from '../../../../../../utils/types';

type Props = {
  positions: Position[];
  onEditPortfolioPositionSignal: (securityKey: string) => void;
  onRemovePortfolioPositionSignal: (position: Position) => void;
  recalculationMode: Nullable<RecalculationMode>;
};

export const PositionList: React.FC<Props> = ({
  positions,
  onEditPortfolioPositionSignal,
  onRemovePortfolioPositionSignal,
  recalculationMode,
}) => {
  if (!positions.length) return null;

  return (
    <Stack spacing={1} className="portfolio-signal-list">
      {positions.map((position, index) => {
        const weight =
          recalculationMode === RecalculationMode.WeightedAverageWithRecalculation ||
          recalculationMode === RecalculationMode.WeightedAverageWithoutRecalculation
            ? roundStringNumber(position.weight)
            : roundStringNumber(position.currentWeight);

        return (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            p={0.5}
            border={1}
            borderRadius={1}
            borderColor="divider"
          >
            <Box>
              <Typography variant="body2" fontWeight={500}>
                {position.name} ({position.symbol})
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Доля: {weight}%
              </Typography>
            </Box>
            <Stack direction="row" spacing={1}>
              <IconButton
                size="small"
                className="portfolio-signal-edit"
                aria-label="Редактировать позицию"
                onClick={() => onEditPortfolioPositionSignal(position.securityKey)}
              >
                <FontAwesomeIcon icon={faExchangeAlt} className="fall" />
              </IconButton>
              <IconButton
                size="small"
                className="portfolio-signal-close"
                aria-label="Закрыть позицию"
                onClick={() => onRemovePortfolioPositionSignal(position)}
              >
                <FontAwesomeIcon icon={faTimes} />
              </IconButton>
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
};
